import {
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Phase } from 'src/app/interfaces/phase';
import { Event } from 'src/app/interfaces/event';
import { Project } from 'src/app/interfaces/project';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Update } from 'src/app/interfaces/update';
import { EventService } from 'src/app/services/event.service';
import { DateTypePipe } from '../../../../pipes/date-type.pipe';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { TranslateModule } from '@ngx-translate/core';
import { EventComponent } from '../../../../components/events/event.component';
import { TranslateTextDirective } from '../../../../directives/translate-text.directive';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgIf, NgFor, NgClass, DatePipe } from '@angular/common';
import {
  animate,
  query,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { DivClickDirective } from 'src/app/directives/div-click.directive';

@Component({
  selector: 'app-project-planning',
  templateUrl: './project-planning.component.html',
  standalone: true,
  imports: [
    NgIf,
    InlineSVGModule,
    NgFor,
    NgClass,
    TranslateTextDirective,
    EventComponent,
    DatePipe,
    TranslateModule,
    TruncateModule,
    DateTypePipe,
    DivClickDirective,
  ],
  animations: [
    trigger('slideIn', [
      transition('void => show', [
        query(
          '.isPast',
          [
            style({ opacity: 0, transform: 'translateY(-10px)' }),
            stagger('75ms', [
              animate(
                '250ms ease-in',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class ProjectPlanningComponent implements OnInit {
  @Input() phases: Phase[];
  @Input() updates: Update[];
  @Input() project: Project;
  currentPhase: number;
  planningLoaded: boolean = false;
  showPastPhases: boolean = false;
  showEmptyMessage: boolean = false;
  planningItems: (Event | Phase)[];
  @ViewChildren('phaseElement') public phaseElements: QueryList<ElementRef>;

  private events: Event[];

  constructor(private router: Router, private eventService: EventService) {}

  ngOnInit() {
    this.initPhasesAndEvents();
  }

  openPhase(phase: Phase) {
    this.router.navigate(['projects', this.project.slug, 'phase', phase.id], {
      state: { phase: phase, project: this.project },
    });
  }

  async initPhasesAndEvents() {
    this.events = this.eventService.sortEvents(
      await this.eventService.getEventsForProject(this.project)
    );
    let atLeastOneInPast = false;
    let atLeastOneInFuture = false;
    this.phases.forEach((phase, index) => {
      phase['index'] = index;
      if (moment().isAfter(phase.endDate)) {
        phase['isPast'] = true;
        atLeastOneInPast = true;
      } else {
        atLeastOneInFuture = true;
      }
      if (
        moment().isSameOrAfter(moment(phase.startDate), 'day') &&
        moment().isSameOrBefore(moment(phase.endDate), 'day')
      ) {
        this.currentPhase = index;
        phase['isCurrent'] = true;
      }
      const { filteredEvents, remainingEvents } = this.events.reduce(
        (result, event) => {
          if (
            moment(event.startDate).isBetween(phase.startDate, phase.endDate)
          ) {
            result.filteredEvents.push(event);
          } else {
            result.remainingEvents.push(event);
          }
          return result;
        },
        { filteredEvents: [], remainingEvents: [] }
      );
      phase.events = filteredEvents;
      this.events = remainingEvents;
      phase.events.map((event) => {
        event.phase = phase;
        event['isPast'] = event.endDate
          ? moment().isAfter(event.endDate)
          : moment().isAfter(event.startDate);
        if (event['isPast']) phase['hasPastEvents'] = true;
        if (phase['isPast']) phase['showPastEvents'] = true;
      });
    });

    this.planningItems = this.phases;
    this.planningItems.map((item) => (item['type'] = 'planning'));
    const leftoverEvents = this.events.filter((event) => !event.phase);
    leftoverEvents.forEach((item) => {
      item['type'] = 'event';
      if (moment().isAfter(item.endDate || item.startDate)) {
        item['isPast'] = true;
        atLeastOneInPast = true;
      } else {
        atLeastOneInFuture = true;
      }
    });
    this.planningItems = this.planningItems.concat(leftoverEvents);
    this.planningItems.sort(
      (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
    );
    this.showPastPhases = !atLeastOneInPast;
    this.showEmptyMessage = !atLeastOneInFuture;
    this.planningLoaded = true;
  }
}
